import './fonts.scss';
import LocaleWrap from './wrapPageElement';
import RootWrap from './wrapRootElement';

export const wrapRootElement = RootWrap;
export const wrapPageElement = LocaleWrap;
